@if (step === 'completed') {
  <checkout-completed></checkout-completed>
} @else {
  <ng-container *ngIf="templateContext$ | async as content">
    @if (content.cart.isLoading) {
      <local-loader></local-loader>
    } @else {
      <div class="container checkout">
        <div class="checkout-header">
          <div class="checkout-header-title">
            <h1>{{ 'checkout.title' | translate }}</h1>
          </div>
          <checkout-tabs [items]="tabs"></checkout-tabs>
        </div>

        <div class="checkout-content">
          <div class="checkout-content-main">
            @if (step === 'modo-entrega') {
              <checkout-delivery-mode></checkout-delivery-mode>
            }
            @if (step === 'endereco-entrega') {
              <checkout-delivery-address></checkout-delivery-address>
            }
            @if (step === 'metodo-pagamento') {
              <checkout-payment-method></checkout-payment-method>
            }
            @if (step === 'pagamento') {
              <checkout-payment></checkout-payment>
            }
            @if (step === 'review') {
              @if (isLoadingOrder()) {
                <div class="message-success w-100">
                  <p class="title">{{ 'checkout.processing.title' | translate }}</p>
                  <div class="message-content">
                    <p>{{ 'checkout.processing.message.title' | translate }}</p>
                    <p>{{ 'checkout.processing.message.desc' | translate }}</p>
                  </div>
                </div>
              } @else {
                <checkout-review></checkout-review>
              }
            }

            <div class="checkout-step-navigation">
              @if (!isFirstStep) {
                <cx-button class="btn-outline" (click)="prevStep()">
                  {{ 'checkout.navigation.back' | translate }}
                </cx-button>
              } @else {
                <p></p>
              }
              @if (!isLastStep) {
                <cx-button (click)="nextStep()" [disabled]="!canProceed">
                  {{ 'checkout.navigation.next' | translate }}
                </cx-button>
              }
            </div>
          </div>

          <div class="checkout-content-values">
            @if (content.cart.data) {
              <cart-totals
                [cart]="content.cart.data"
                [buttonText]="'cart.summaryTotals.concludeOrder' | translate"
                [insideButton]="step === 'review'"
                (buttonClick)="makeOrder()"
                [isLoadingButton]="isLoadingOrder()"
                [disableButton]="!content.hasAvailableEntries || isLoadingOrder()"
              />
            }
            @if (step === 'review') {
              <cx-button class="btn btn-outline w-100" (click)="goToCart()">{{ 'checkout.review.backToCart' | translate }}</cx-button>
            }
          </div>
        </div>
      </div>
    }
  </ng-container>
}
